import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import axios from "axios"
import TicketControl from "./TicketControl"
import TicketNotes from "./TicketNotes"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

function ViewTicket({
  viewTicketModal,
  ToggleviewTicket,
  ticketControlled,
  editing,
  setEditing,
  updatePermission,
  setAuth,
  setViewTicketModal,
  setNewTicketData,
  ToggleviewNewTicket,
  viewNewTicketModal
}) {
 

  const [isdegree, setIsdegree] = useState()
  const [activeTab, setActiveTab] = useState("1")
  const formRef = useRef()
  const history = useHistory()
  const [submitANewTicket, setSubmitANewTicket] = useState()
  const [reset, setReset] = useState(false)
  

  return (
    <React.Fragment>
      <Modal
        isOpen={viewTicketModal}
        toggle={ToggleviewTicket}
        className="modal-lg"
      >
        <ModalBody>
          <Nav
            fill
            tabs
            className="rounded nav-tabs-custom col-4"
            role="tablist"
          >
            <NavItem>
              <NavLink
                className={classnames({
                  active: activeTab === "1",
                })}
                onClick={() => setActiveTab((1).toString())}
              >
                Ticket Control
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: activeTab === "2",
                })}
                onClick={() => setActiveTab((2).toString())}
              >
                Notes
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId={(1).toString()}>
              <TicketControl
                ticketControlled={ticketControlled}
                editing={editing}
                setEditing={setEditing}
                updatePermission={updatePermission}
                setAuth={setAuth}
                formRef={formRef}
                submitANewTicket={submitANewTicket}
                ToggleviewTicket={ToggleviewTicket}
                setIsdegree={setIsdegree}
                ToggleviewNewTicket={ToggleviewNewTicket}
                setNewTicketData={setNewTicketData}
                viewNewTicketModal={viewNewTicketModal}
                reset={reset}
              />
            </TabPane>
            <TabPane tabId={(2).toString()}>
              <TicketNotes ticketControlled={ticketControlled} />
            </TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              ToggleviewTicket()
              setEditing(!editing)            

            }}
            className="bg-secondary"
          >
            Cancel
          </Button>
          {ticketControlled.TransferTo && !ticketControlled["Copy"]   && (
            <Button
              onClick={() => {
                setSubmitANewTicket("submitANewTicket")
                formRef.current.props.onSubmit()
              }}
              className="bg-primary"
              disabled={!isdegree}
            >
              Submit & Add NewTicket
            </Button>
          )}
          {(ticketControlled.TransferTo === "18" ||
            ticketControlled.TransferTo === "17" ||
            ticketControlled.TransferTo === "16") && (
            <Button
              onClick={() => {
                // history.push(`/rd1-reasons/${ticketControlled.ProjectID}`)
                ticketControlled.TransferTo === "18"
                  ? history.push(`/rd1-reasons/${ticketControlled.ProjectID}`)
                  : ticketControlled.TransferTo === "17"
                  ? history.push(`/rd2-Material/${ticketControlled.ProjectID}`)
                  : ticketControlled.TransferTo === "16" &&
                  history.push(`/rd-DR/${ticketControlled.ProjectID}`)
                  ToggleviewTicket()
              }}
              className="bg-primary"
            >
              {ticketControlled.TransferTo === "18"
                ? "Add RD1"
                : ticketControlled.TransferTo === "17"
                ? "Add RD2"
                : ticketControlled.TransferTo === "16" && "Add DR"}
            </Button>
          )}
          <Button
            type="submit"
            className="bg-primary"
            onClick={() => {
              formRef.current.props.onSubmit()
              setSubmitANewTicket("")
              // setViewTicketModal(false)
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default ViewTicket
